import { Link, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import './Menu.css';

function Menu() {
  const location = useLocation();

  // Подсветка пункта меню. Для pair-analysis учитываем параметр :config
  const isActive = (path) => {
    if (path === '/pair-analysis') {
      return location.pathname.startsWith('/pair-analysis');
    }
    return location.pathname === path;
  };

  // Прячем/показываем Telegram BackButton и скроллим вверх при смене роута
  useEffect(() => {
    const root = document.getElementById('root');
    if (root) root.scrollTo(0, 0);

    const isSettings = location.pathname.startsWith('/settings');
    try {
      const tg = window?.Telegram?.WebApp;
      if (tg?.BackButton) {
        tg.BackButton.isVisible = !!isSettings;
      }
    } catch {
      /* noop */
    }
  }, [location.pathname]);

  return (
    <nav className="Menu">
      <div className={`${isActive('/futures-screen') ? 'background-blur' : ''}`}></div>
      <div className='menu-wrapper'>
        <Link to="/app" className={`menu-link ${isActive('/app') ? 'link-active' : ''}`}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9 22V12H15V22" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </Link>

        <Link to="/futures-screen" className={`menu-link ${isActive('/futures-screen') ? 'link-active' : ''}`}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M23 6L13.5 15.5L8.5 10.5L1 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M17 6H23V12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </Link>

        <Link to="/notifications" className={`menu-link ${isActive('/notifications') ? 'link-active' : ''}`}>
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none">
            <path d="M12 3.5C8.5 3.5 5.5 6.5 5.5 10V15L4 17H20L18.5 15V10C18.5 6.5 15.5 3.5 12 3.5Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9.5 17.5C9.5 19 10.6 20.5 12 20.5C13.4 20.5 14.5 19 14.5 17.5" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            <path d="M12 3.5V2" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </Link>

        <Link to="/pair-analysis" className={`menu-link ${isActive('/pair-analysis') ? 'link-active' : ''}`}>
        <svg style={{scale: '0.7'}} xmlns="http://www.w3.org/2000/svg" width="44px" height="44px" viewBox="0 0 24 24" fill="none"> <path d="M21 3L14 9L10 5L3 11M4.5 21C3.67157 21 3 20.3284 3 19.5V17.5C3 16.6716 3.67157 16 4.5 16C5.32843 16 6 16.6716 6 17.5V19.5C6 20.3284 5.32843 21 4.5 21ZM11.5 21C10.6716 21 10 20.3284 10 19.5V14.5C10 13.6716 10.6716 13 11.5 13C12.3284 13 13 13.6716 13 14.5V19.5C13 20.3284 12.3284 21 11.5 21ZM18.5 21C17.6716 21 17 20.3284 17 19.5V16.5C17 15.6716 17.6716 15 18.5 15C19.3284 15 20 15.6716 20 16.5V19.5C20 20.3284 19.3284 21 18.5 21Z" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/> </svg>
        </Link>

        <Link to="/profile" className={`menu-link ${isActive('/profile') ? 'link-active' : ''}`}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </Link>
      </div>
    </nav>
  );
}

export default Menu;
